import { api, mediaUrl } from "@/lib/api";

export async function uploadFile(file, kind = "image") {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("kind", kind);
  const { data } = await api.post("/uploads", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return { ...data, fullUrl: mediaUrl(data.url) };
}
